import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import useAuth from "../helpers/useAuth";

const PrivateRoute = ({ Component }) => {
  useAuth();
  const navigate = useNavigate();
  const isLogin = useSelector(state => state.auth.isAuthenticated);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    
    if (!token && !isLogin) {
      navigate("/");
    }
  }, [navigate, isLogin]);

  return Component ;
};

export default PrivateRoute;


